import Vue from 'vue'
import VueRouter from 'vue-router'
import LogIn from "@/components/LogIn.vue";

Vue.use(VueRouter)

function hasEbusToken() {
  const token = localStorage.getItem('ebus_token');
  console.log("token:", token);
  return typeof token === 'string' && token.trim() !== '';
}

const routes = [
  {
    path: '/',
    name: 'LogIn',
    component: LogIn,
    beforeEnter: (to, from, next) => {
      if (hasEbusToken()) {
        console.log("token true");
        next({name: 'Main'});
        return;
      }

      next();
    }
  },
  {
    path: '/registration/',
    name: 'Registration',
    component: () => import('@/components/Registration.vue')
  }, {
    path: '/fooldal',
    name: 'Main',
    component: () => import('@/components/Main.vue'),
    beforeEnter: (to, from, next) => {
      if (!hasEbusToken()) {
        next({name: 'LogIn'});
        return;
      }

      next();
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
  // allowedForGuest: ['Login', 'Register']
})

export default router

